import React from 'react';
import { ReactComponent as FigUser03Component } from './FigUser03.svg';

const FigUser03 = (props) => <FigUser03Component {...props} />;

export default FigUser03;
